import React from 'react'
import './Button.css'
import lishalResume from '../../assets/cv/LishalBhariResume.pdf'
function Buttons({theme}) {
  const buttonBg={
    background:theme==="light"?'var(--white)':'var(--hoverDark)'
  }
  const buttonColor={
    color:theme==="light"?'var(--boldColor)':'var(--darkModeSemiboldColor)'
  }
  function sendEmail() {
    const email = 'lbhari188@gmail.com';
    const mailtoLink = `mailto:${email}`;
    window.location.href = mailtoLink;
  }
  return (
    <div className='buttonContainer flex'>
      <a className='link' href={lishalResume} download='Lishal-CV'>
        <button className='mainBgColor button flex'>
           <span className='lightBoldColor'>Download CV</span> 
            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 28 24" fill="none">
                <path d="M21.5189 20H5.78098C5.48284 20 5.19691 20.1054 4.9861 20.2929C4.77528 20.4804 4.65685 20.7348 4.65685 21C4.65685 21.2652 4.77528 21.5196 4.9861 21.7071C5.19691 21.8946 5.48284 22 5.78098 22H21.5189C21.8171 22 22.103 21.8946 22.3138 21.7071C22.5246 21.5196 22.6431 21.2652 22.6431 21C22.6431 20.7348 22.5246 20.4804 22.3138 20.2929C22.103 20.1054 21.8171 20 21.5189 20ZM12.8518 17.71C12.9587 17.801 13.0848 17.8724 13.2228 17.92C13.3573 17.9729 13.5028 18.0002 13.6499 18.0002C13.7971 18.0002 13.9426 17.9729 14.0771 17.92C14.2151 17.8724 14.3412 17.801 14.4481 17.71L18.9446 13.71C19.1563 13.5217 19.2752 13.2663 19.2752 13C19.2752 12.7337 19.1563 12.4783 18.9446 12.29C18.733 12.1017 18.4459 11.9959 18.1465 11.9959C17.8471 11.9959 17.56 12.1017 17.3484 12.29L14.7741 14.59V3C14.7741 2.73478 14.6557 2.48043 14.4448 2.29289C14.234 2.10536 13.9481 2 13.6499 2C13.3518 2 13.0659 2.10536 12.8551 2.29289C12.6442 2.48043 12.5258 2.73478 12.5258 3V14.59L9.95153 12.29C9.84672 12.1968 9.72229 12.1228 9.58535 12.0723C9.4484 12.0219 9.30162 11.9959 9.1534 11.9959C9.00517 11.9959 8.85839 12.0219 8.72145 12.0723C8.5845 12.1228 8.46007 12.1968 8.35526 12.29C8.25045 12.3832 8.1673 12.4939 8.11058 12.6158C8.05385 12.7376 8.02466 12.8681 8.02466 13C8.02466 13.1319 8.05385 13.2624 8.11058 13.3842C8.1673 13.5061 8.25045 13.6168 8.35526 13.71L12.8518 17.71Z" fill="#3D3D3D"/>
            </svg>
        </button>
        </a>
        <button className='button' style={buttonBg} onClick={sendEmail}>
            <span className='lightBoldColor' style={buttonColor}>Contact me</span>
        </button>
    </div>
  )
}

export default Buttons